module.exports = __webpack_public_path__ + "static/img/logo.68f5ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 28